/**
 * ClientApp/src/apps/components/mapViewers/tests/PieMap/hooks/usePieMapInit.js
 *
 * Minimal init hook for the PieMap sandbox.
 *
 * Loads:
 *  - Test A — simple FeatureLayer count clustering
 *  - Test D — smart FeatureLayer pie clustering
 *  - Test F — MapImageLayer clustering
 */

import { useCallback } from "react";

import {
  initPieMapLayers,
  buildPieMapImageLayers,
} from "../utils/pieMapUtils";

import { TestPieLayers } from "../source/testPieLayers";
import { MapServices } from "../source/serviceMapList";

const usePieMapInit = () => {
  return useCallback((event) => {
    const { map, view } = event.target;

    // Tests A + D
    initPieMapLayers(
      map,
      view,
      Object.values(TestPieLayers)
    );

    // Test F
    buildPieMapImageLayers(
      map,
      Object.values(MapServices)
    );
  }, []);
};

export default usePieMapInit;